import { NOTATION_MATCH, NOTATION_PLAYER, SURVEY_PRONOSTIC, SURVEY_YES_NO } from "./importConstants"

export const createSurvey = (surveyType, payload) => {

    let surveyToCreate;

    switch(surveyType){
        case SURVEY_YES_NO : 
            surveyToCreate = surveyYesNo(payload)

        break;
        case SURVEY_PRONOSTIC : 
            surveyToCreate = surveyPronostic(payload)

        break;
        default :
            console.log("Survey type unknown for gemafacttrigger : ",surveyType )
    }

    return surveyToCreate
}

const surveyYesNo = (payload) => {

    const {question, displayDate, period, timer, idMatch} = payload

    return {
        idMatch,
        timer,
        period,
        displayDate,
        question,

        type: "survey",
        creation: new Date(),
        
        choices:[
            {label:"",entries:[
                {
                    id: Math.random(),
                    type:"txt",
                    name:"Oui"}]
            },
            {label:"",entries:[
                {
                    id: Math.random(),
                    type:"txt",
                    name:"Non"}]
            },
        ],
        options:{
            numberOfChoices : 1,
            validate : false
        },
        
        votes:[],
        tags:[],
        isPin:false
    }
}

const surveyPronostic = (payload) => {

    const {question, displayDate, period, timer, idMatch, isPin = false, match} = payload

    const{homeTeam, awayTeam} = match

    const choices = [
        {label:"",entries:[{
                    id: Math.random(),
                    type:"txt",
                    name: "Victoire "+homeTeam.name
                }]
        }
    ]

    if(match.discipline !== 'basket'){
        choices.push({label:"",entries:[{
                    id: Math.random(),
                    type:"txt",
                    name: "Match nul"
                }]
        })
    }

    choices.push({label:"",entries:[{
                    id: Math.random(),
                    type:"txt",
                    name: "Victoire "+awayTeam.name
                }]
    })

    return {
        idMatch,
        timer,
        period,
        displayDate,
        question,
        isPin,

        type: "survey",
        creation: new Date(),
        
        choices,
        options:{
            numberOfChoices : 1,
            validate : false
        },
        
        votes:[],
        tags:[]
    }
}

export const createNotation = (notationType, payload) => {

    let notationToCreate;

    switch(notationType){
        case NOTATION_PLAYER : 
            notationToCreate = notationPlayer(payload)
        break;
        case NOTATION_MATCH : 
            notationToCreate = notationMatch(payload)

        break;
        default :
            console.log("Notation type unknown for gemafacttrigger : ",notationType )
    }

    return notationToCreate
}

const notationPlayer = (payload) => {

    const {idPlayer, idMatch, idTeam, timer, period, displayDate} = payload

    return {
        idMatch,
        type:"notation",
        creation:new Date(),
        globalTarget: idTeam,
        preciseTarget:"players",
        exactTarget:[idPlayer],
        timer,
        period,
        displayDate,
        votes:[],
        details:[],
        tags:[],
        isPin:false

    }
}

const notationMatch = (payload) => {

    const {idMatch, timer, period, displayDate} = payload

    return {
        idMatch,
        type:"notation",
        creation:new Date(),
        globalTarget: "match",
        preciseTarget:"team",
        exactTarget:[],
        timer,
        period,
        displayDate,
        votes:[],
        details:[],
        tags:[],
        isPin:false

    }
}